import { IFormValues } from './interfaces';

export const DEFAULT_FORM_DATA: IFormValues = {
  title: '',
  saved: false,
  argumentsCommand: '',
  path: '',
};
